import PropTypes from 'prop-types'
import PropTypesUtils from '@utils/propTypes'
const Text = ({ children, type, bold }) => (
  <span className={`f-${type} ${bold ? 'bold' : ''}`}>{children}</span>
)

Text.defaultProps = {
  type: 'text-m',
  bold: false,
}
Text.propTypes = {
  children: PropTypesUtils.children.isRequired,
  type: PropTypes.oneOf([
    'h1',
    'h2',
    'h3',
    'nav',
    'tagline',
    'text-l',
    'text-m',
    'text-s',
    'text-xs',
  ]),
  bold: PropTypes.bool,
}

export default Text
